import React from 'react';
import { getVacationBanner, formatVacationDate } from '../utils/vacationBanner';

export const VacationBanner = ({ settings, className = '' }) => {
  const banner = getVacationBanner(settings);
  if (!banner) return null;

  if (banner.phase === 'upcoming') {
    return (
      <div className={`bg-amber-50 border-2 border-amber-300 rounded-lg p-4 mb-6 ${className}`} data-testid="vacation-banner-upcoming">
        <div className="flex items-start gap-3">
          <span className="text-2xl">🌴</span>
          <div>
            <h4 className="font-semibold text-amber-800">Upcoming Holiday Notice</h4>
            {banner.message && <p className="text-amber-700 text-sm mt-1">{banner.message}</p>}
            {(banner.startDate || banner.endDate) && (
              <p className="text-amber-700 text-sm mt-2 font-medium">
                🗓️ We&apos;ll be away
                {banner.startDate ? ` from ${formatVacationDate(banner.startDate)}` : ''}
                {banner.endDate ? ` until ${formatVacationDate(banner.endDate)}` : ''}
              </p>
            )}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`bg-blue-100 border-2 border-blue-400 rounded-lg p-4 mb-6 ${className}`} data-testid="vacation-banner-active">
      <div className="flex items-start gap-3">
        <span className="text-2xl">🏖️</span>
        <div>
          <h4 className="font-semibold text-blue-800">We&apos;re on Vacation!</h4>
          {banner.message && <p className="text-blue-700 text-sm mt-1">{banner.message}</p>}
          {banner.endDate && (
            <p className="text-blue-600 text-sm mt-2 font-medium">
              📅 Back on: {formatVacationDate(banner.endDate)}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default VacationBanner;
